import React, { useState, useEffect } from "react";
import { getAccessTokenApi } from "../../../api/auth"; //obtencion del token del usuaario
import { getUsersActiveApi } from "../../../api/user";
import ListUsers from "../../../components/Admin/Users/ListUsers";
import "./Users.scss";

export default function User() {
  //creacion del estado donde se guardaran los usuarios
  const [usersActive, setUsersActive] = useState([]); //estado para usuarios activos
  const [usersInactive, setUsersInactive] = useState([]); //estado para usuarios inactivos
  const [reloadUsers, setReloadUsers] = useState(false);
  const token = getAccessTokenApi();

  useEffect(() => {
    //muestra los ususarios
    getUsersActiveApi(token, true).then((response) => {
      //usuarios activos
      setUsersActive(response.users);
    });
    getUsersActiveApi(token, false).then((response) => {
      //usuarios inactivos
      setUsersInactive(response.users);
    });
    setReloadUsers(false);
  }, [token, reloadUsers]);
  return (
    <div className="users">
      <ListUsers
        usersActive={usersActive}
        usersInactive={usersInactive}
        setReloadUsers={setReloadUsers}
      />
    </div>
  );
}
